// @flow

export function getEnvVarOrCry(key: string): any {
  const value = ENV_CONSTANTS[key];

  if(value === undefined || value === null) {
    throw new Error(`getEnvVarOrCry - Environment variable ${key} not defined`);
  }

  return value;
}
